module.exports = __webpack_public_path__ + "static/media/frames-14.360d12b6.jpg";